import React, { useEffect, useState } from 'react';
import api from '../api/client';

interface Props {
  productId: any;
  locationId: any;
  value?: any;
  onSelect: (batchId: any, batch: any) => void;
}

/** Batch picker for products that track expiry. Renders nothing when there are none. */
const BatchPicker: React.FC<Props> = ({ productId, locationId, value, onSelect }) => {
  const [batches, setBatches] = useState<any[]>([]);

  useEffect(() => {
    if (!productId) { setBatches([]); return; }
    api.get('/inventory/batches', { params: { product_id: Number(productId), location_id: locationId ? Number(locationId) : undefined } })
      .then(r => {
        const b = r.data.data || [];
        setBatches(b);
        if (b.length && !value) onSelect(b[0].id, b[0]);
      })
      .catch(() => setBatches([]));
  }, [productId, locationId]); // eslint-disable-line

  if (!batches.length) return null;

  const chosen = batches.find((b: any) => String(b.id) === String(value)) || batches[0];
  const colour = chosen?.status === 'expired' ? 'var(--red)' : chosen?.status === 'expiring' ? 'var(--amber)' : 'var(--tx3)';
  const label = (b: any) =>
    `${b.batch_no || 'no batch no.'} · ${b.expiry_date ? new Date(b.expiry_date).toLocaleDateString() : 'no expiry'} · ${Number(b.qty_remaining)}`
    + (b.status === 'expired' ? ' — EXPIRED' : b.status === 'expiring' ? ` — ${b.days_left}d left` : '');

  return (
    <div style={{ marginTop: 3 }}>
      <select className="form-control" style={{ fontSize: 11, padding: '3px 6px', color: colour }}
        value={value || chosen?.id || ''}
        onChange={e => onSelect(e.target.value, batches.find((b: any) => String(b.id) === e.target.value))}>
        {batches.map((b: any) => <option key={b.id} value={b.id}>{label(b)}</option>)}
      </select>
      {chosen?.status === 'expired' && <div style={{ fontSize: 10, color: 'var(--red)', marginTop: 2 }}>This batch has expired</div>}
      {chosen?.status === 'expiring' && <div style={{ fontSize: 10, color: 'var(--amber)', marginTop: 2 }}>Expires in {chosen.days_left} days</div>}
    </div>
  );
};

export default BatchPicker;
